<form [formGroup]="employeeForm" class="my-1">
    <div class="row">
        <ng-container *ngFor="let data of crewData">
            <div [ngClass]="fieldWidth ? 'col-6':'col-4'">
                <app-drop-down [formData]="employeeForm" [dropDownData]="data" (dropDownIds)="setAssignedData($event)"
                 [patchData]="assignedCrewId"  ></app-drop-down>
            </div>
        </ng-container>
    </div>
</form>